function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#247dbd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M30.255,12.255,29.1,10.245a1.093,1.093,0,0,0-1.491-.4l-6.933,4.008a.282.282,0,0,1-.422-.246V5.59A1.086,1.086,0,0,0,19.16,4.5H16.84a1.086,1.086,0,0,0-1.09,1.09v8.023a.282.282,0,0,1-.422.246L8.4,9.851a1.093,1.093,0,0,0-1.491.4l-1.16,2.011a1.083,1.083,0,0,0,.4,1.484l6.94,4.015a.278.278,0,0,1,0,.485l-6.94,4.015a1.091,1.091,0,0,0-.4,1.484L6.9,25.755a1.093,1.093,0,0,0,1.491.4l6.933-4.008a.282.282,0,0,1,.422.246v8.023a1.086,1.086,0,0,0,1.09,1.09h2.32a1.086,1.086,0,0,0,1.09-1.09v-8.03a.284.284,0,0,1,.422-.246L27.6,26.149a1.093,1.093,0,0,0,1.491-.4l1.16-2.011a1.083,1.083,0,0,0-.4-1.484l-6.94-4.015a.278.278,0,0,1,0-.485l6.94-4.015A1.089,1.089,0,0,0,30.255,12.255Z",
  transform: "translate(-5.598 -4.5)"
});

const SvgIconEspecialidad = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.803,
    height: 27.007,
    viewBox: "0 0 24.803 27.007",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEspecialidad, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Especialidad.cadbcd82.svg";
export { ForwardRef as ReactComponent };